import * as React from 'react'
import {useCallback, useMemo} from 'react'
import Dialog from '@mui/material/Dialog'
import ListItemText from '@mui/material/ListItemText'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Slide from '@mui/material/Slide'
import {TransitionProps} from '@mui/material/transitions'
import {useTranslation} from 'react-i18next'
import {useDispatch, useSelector} from 'react-redux'
import {hideCustomerSwitcher, meSelector,} from '../authentication/redux'
import {compose, prop, sortBy, toLower} from 'ramda'
import {ThunkDispatch} from '@reduxjs/toolkit'
import {RootState} from './store'
import CloseIcon from '@mui/icons-material/Close'
import {Alert, IconButton, ListItemButton} from '@mui/material'
import {useHistory} from 'react-router'

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction='right' ref={ref} {...props} />
})

// @ts-ignore
const sortByNameCaseInsensitive = sortBy(compose(toLower, prop('name')))

export const CustomerSelector = () => {
    const { t } = useTranslation()
    const me = useSelector(meSelector)
    const history = useHistory()
    const dispatch = useDispatch<ThunkDispatch<RootState, any, any>>()

    // @ts-ignore
    const sortedCustomers: CustomerInfo[] = useMemo(() => me?.customerInfos ? sortByNameCaseInsensitive(me?.customerInfos) : [], [me?.customerInfos])

    const setCustomer = useCallback(async (customerId) => {
        history.push("/?RelayState=" + customerId)
        history.go(0)
    }, [history])

    return (
        <div>
            <Dialog
                fullScreen
                open={true}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        {me?.customerOriginId &&
                            <IconButton
                                edge='start'
                                color='inherit'
                                onClick={() => dispatch(hideCustomerSwitcher())}
                                aria-label='close'
                            >
                                <CloseIcon/>
                            </IconButton>
                        }
                        <Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
                            {t('customer-selector.title')}
                        </Typography>
                    </Toolbar>
                </AppBar>
                {!me?.customerOriginId && me?.customerInfos && me.customerInfos?.length > 0 && <div><Alert severity="warning">{t('customer-selector.warning-customer-not-found')}</Alert></div>}
                <List>
                    {
                        sortedCustomers.map((customer, index) =>
                            <React.Fragment key={index}>
                                <ListItemButton
                                    selected={customer.originCustomerId === me?.customerOriginId}
                                    onClick={() => {
                                        setCustomer(customer.originCustomerId);
                                    }}>
                                    <ListItemText primary={customer.name} secondary={customer.originCustomerId} />
                                </ListItemButton>
                                {index !== sortedCustomers.length - 1 && <Divider />}
                            </React.Fragment>)
                    }
                </List>
            </Dialog>
        </div>
    )
}